import * as React from 'react';
import type { SVGProps } from 'react';
const SvgUserprofile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={36}
    height={36}
    fill='none'
    viewBox='0 0 100 100'
    {...props}
  >
    <g fill='currentColor' clipPath='url(#userprofile_svg__clip0_7066_67688)' opacity={0.5}>
      <path d='M100 50.41c-.177 27.953-22.328 49.726-50.457 49.599C21.72 99.873-.147 77.581 0 49.491.147 22.106 22.71-.128 50.24 0 78.055.127 100.176 22.536 100 50.41M80.273 82.89c13.298-9.944 18.579-31.766 12.032-48.856-6.89-18-26.077-30.476-44.695-29.058C26.499 6.58 9.903 21.02 5.663 41.454c-3.2 15.438 3.768 35.54 14.24 41.113 16.685-23.054 44.127-23.045 60.36.323z' />
      <path d='M49.828 26.79c10.168-.06 17.872 7.616 17.823 17.764-.04 9.719-7.93 17.482-17.725 17.452-9.716-.029-17.597-7.91-17.617-17.618-.02-9.816 7.665-17.54 17.519-17.599' />
    </g>
  </svg>
);
export default SvgUserprofile;
